import React, { useRef, useState } from "react";
import I18n from "i18n";
import { useEffect } from "react";
import DateFormatter from "../libraries/dateFormatter";

export default function DetailViewCommentItem({
  comment,
  currentUserId,
  onUpdate,
  onDelete,
}: {
  comment: Backbone.Model;
  currentUserId: string;
  onUpdate: (comment: Backbone.Model, newText: string) => void;
  onDelete: (comment: Backbone.Model) => void;
}) {
  const [editing, setEditing] = useState(false);
  const [updateLock, setUpdateLock] = useState(false);
  const inputRef = useRef<HTMLTextAreaElement | null>(null);

  const isOwnComment = comment.get("creator_id") === currentUserId;

  function enterEditMode() {
    setEditing(true);
    setTimeout(() => {
      inputRef.current?.select();
    }, 0);
  }

  function leaveEditMode() {
    setEditing(false);
    setUpdateLock(false);
  }

  function handleCommentInput(event: React.KeyboardEvent<HTMLTextAreaElement>) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      updateComment();
    }
  }

  function updateComment() {
    if (!updateLock) {
      const value = inputRef.current?.value;
      if (value && value !== comment.get("text")) {
        setUpdateLock(true);
        onUpdate(comment, value);
      }
    }
  }

  function handleBlur() {
    updateComment();
  }

  useEffect(() => {
    leaveEditMode();
  }, [comment.get("text")]);

  return (
    <div className={`comment mtm ${editing ? "active" : ""}`} id={`comment-${comment.get("id")}`}>
      <div className="comment-content">
        <span className="comment-author">{comment.get("author")}</span>
        {editing ? (
          <textarea
            className="textarea textarea--expanding textarea--small comment-comment-editor"
            placeholder={I18n.t("webapp.agents.results.result_details.comment_prompt")}
            data-comment-text
            defaultValue={comment.get("text")}
            ref={inputRef}
            onKeyPress={handleCommentInput}
            onBlur={handleBlur}
          />
        ) : (
          <div className="comment-comment">{comment.get("text")}</div>
        )}
      </div>
      <div className="comment-meta">
        {editing ? (
          <div className="comment-actions">
            <span className="comment-action">
              <a
                onClick={() => updateComment()}
                data-update-comment={comment.get("id")}
              >
                <i className="comment-action-icon comment-action-icon--edit"></i>
                {I18n.t("webapp.agents.results.result_details.comment_save")}
              </a>
            </span>
          </div>
        ) : (
          <>
            <span className="comment-timestamp">
              {DateFormatter.formatRelativeDate(comment.get("created_at"))}
            </span>
            {isOwnComment && (
              <div className="comment-actions">
                <span className="comment-action">
                  <a
                    onClick={enterEditMode}
                    data-edit-comment={comment.get("id")}
                  >
                    <i className="comment-action-icon comment-action-icon--edit"></i>
                    {I18n.t("webapp.agents.results.result_details.comment_edit")}
                  </a>
                </span>
                <span className="comment-action">
                  <a
                    onClick={() => onDelete(comment)}
                    data-delete-comment={comment.get("id")}
                  >
                    <i className="comment-action-icon comment-action-icon-trash"></i>
                    {I18n.t("webapp.agents.results.result_details.comment_delete")}
                  </a>
                </span>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}